module.exports = __webpack_public_path__ + "img/work-together-hotels.e63af9f9.jpg";